import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { makeStyles } from '@mui/styles';

export const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  zIndex: 10,
  height: '5rem',
  width: '100%',
  backgroundColor: 'transparent',
  padding: '0.5rem 2rem',
  position: 'sticky',
  top: '0',
}));

// Style for the SVG logo - using sx prop pattern for MUI v7
export const logoStyle = {
  width: '4rem',
  fill: (theme) => theme.palette.primary.main,
};

export const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 10,
    height: '5rem',
    width: '100%',
    backgroundColor: 'white',
    padding: '0 2rem',
    position: 'sticky',
    top: '0',
  },
  logo: {
    width: '4rem',
    fill: theme?.palette?.primary?.main || '#003C63',
  },
}));
